import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

type ConfiguracaoStore = {
	empresaSelectorLayout: "grade" | "lista";
	showBannerInstrucoesUso: boolean;
	hasUnsavedData: boolean;
	hideButtonSalvar: boolean;
};

export const useConfiguracaoStore = create<ConfiguracaoStore>()(
	devtools(
		persist(
			(_) => ({
				empresaSelectorLayout: "lista",
				showBannerInstrucoesUso: true,
				hasUnsavedData: false,
				hideButtonSalvar: false,
			}),
			{
				name: "configuracao",
				partialize: (state) => ({
					empresaSelectorLayout: state.empresaSelectorLayout,
					showBannerInstrucoesUso: state.showBannerInstrucoesUso,
				}),
			},
		),
		{ name: "configuracao" },
	),
);
